import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from '../../utils/convergence'
import { isNullOrUndefined } from '@afterpay/utils'
import styles from './styles.module.css'
import { togglePPAModal, useAppDispatch, useCheckoutState, useCheckoutToken, useGetPPAModalState, useLazyGetCheckoutPpaDocumentQuery } from '../../state'
import { Button, Icon, Loader, Modal, useDesignLanguagePerClass } from '@afterpaytouch/core'
import { PPAIframe } from './PPAIframe'

export const PPAModal: FC = () => {
  const [getPpaDocument, { data: ppaDocumentData, isError: ppaDocIsError, isLoading: lazyPpaDocumentIsLoading }] = useLazyGetCheckoutPpaDocumentQuery()
  const { t } = useTranslation()

  const [isPpaError, setIsPpaError] = useState<boolean>(false)
  const { open, isPaymentAuth } = useGetPPAModalState()
  const { started } = useCheckoutState()
  const docId = started?.purchasePaymentAgreementDocumentId
  const token = useCheckoutToken()
  const dispatch = useAppDispatch()
  const designLanguageClass = useDesignLanguagePerClass(styles)

  const onModalDropbackClick = (): void => {
    dispatch(togglePPAModal())
  }

  const printPPA = (): void => {
    const PPAIframe: HTMLIFrameElement | null = document.querySelector('#ppa-list')
    if (isNullOrUndefined(PPAIframe) || isNullOrUndefined(PPAIframe.contentWindow)) {
      return
    }
    PPAIframe.contentWindow?.print()
  }

  useEffect(() => {
    if (open) {
      if (isNullOrUndefined(docId)) {
        return
      }
      getPpaDocument({ token, docId })
    }
  }, [open, docId, token])

  useEffect(() => {
    if (ppaDocIsError) {
      setIsPpaError(true)
    }
  }, [ppaDocIsError, open])

  return (
    <Modal show={open} onBackdropClick={onModalDropbackClick} showCloseButton={true} testNameSpace='ppa-modal'>
      <div className={designLanguageClass.iframeModalBtn}>
        <Button.Link type='button' aria-label={t('summary:terms:PPA:print')} onClick={printPPA} disabled={lazyPpaDocumentIsLoading}>
          <Icon.Printer size='Medium' color='Black' />
        </Button.Link>
        <Button.Link type='button' aria-label={t('summary:terms:PPA:close')} onClick={onModalDropbackClick}>
          <Icon.Close size='Medium' color='Black' />
        </Button.Link>
      </div>
      {lazyPpaDocumentIsLoading ? <Loader /> : <PPAIframe ppa={ppaDocumentData?.renderedHtml} isPaymentAuth={isPaymentAuth} isPpaError={isPpaError} />}
    </Modal>
  )
}
